import { restClient } from '@/Core'

import type { IDashboardEmployee } from '@/Ship/Contracts/IActivityDashboard'

/** Співробітники — ресурс `Setting.User`: бек віддає лише активних (`SPEC-005`). */
const USERS_URL = '/services/users'

/** Скільки варіантів показує селект без пошуку; далі — пошуком за ПІБ. */
export const EMPLOYEE_OPTIONS_LIMIT = 50

interface UserListResponse {
    items?: Array<Record<string, unknown>>
}

/**
 * Варіанти «Фільтра по співробітнику»: перша сторінка або пошук `q` — той
 * самий параметр, що в ядрового селекта ресурсу.
 */
export const LoadDashboardEmployeesTask = async (query: string, signal?: AbortSignal): Promise<IDashboardEmployee[]> => {
    const searchParams: Record<string, string | number> = { limit: EMPLOYEE_OPTIONS_LIMIT }

    if (query.trim() !== '') searchParams['q'] = query.trim()

    const response = (await restClient.get(USERS_URL, { searchParams, ...(signal ? { signal } : {}) })) as unknown as UserListResponse | null

    return (response?.items ?? [])
        .map((item) => ({
            uuid: typeof item['uuid'] === 'string' ? item['uuid'] : '',
            fullName: typeof item['fullName'] === 'string' ? item['fullName'] : '',
        }))
        .filter((item) => item.uuid !== '')
}
